function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var BackInStock = /*#__PURE__*/function (_HTMLElement) {
  function BackInStock() {
    var _this;
    _classCallCheck(this, BackInStock);
    _this = _callSuper(this, BackInStock);
    _this.form = null;
    _this.emailInput = null;
    _this.submitButton = null;
    _this.messageContainer = null;
    _this.variantId = null;
    _this.productId = null;
    _this.productTitle = null;
    _this.variantTitle = null;
    return _this;
  }
  _inherits(BackInStock, _HTMLElement);
  return _createClass(BackInStock, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.init();
    }
  }, {
    key: "init",
    value: function init() {
      this.variantId = this.dataset.variantId || null;
      this.productId = this.dataset.productId || null;
      this.productTitle = this.dataset.productTitle || null;
      this.variantTitle = this.dataset.variantTitle || null;
      this.form = this.querySelector('.back-in-stock-form');
      this.emailInput = this.querySelector('.back-in-stock-form__email');
      this.submitButton = this.querySelector('.back-in-stock-form__submit');
      this.messageContainer = this.querySelector('.back-in-stock-form__message');
      if (this.form && this.emailInput && this.submitButton) {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }
    }
  }, {
    key: "handleSubmit",
    value: function () {
      var _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
        var email, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              event.preventDefault();
              event.stopPropagation();
              if (!(!this.emailInput || !this.submitButton || !this.variantId || !this.productId)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              email = this.emailInput.value.trim();
              if (this.validateEmail(email)) {
                _context.n = 2;
                break;
              }
              this.showMessage('Please enter a valid email address.', 'error');
              return _context.a(2);
            case 2:
              this.setLoadingState(true);
              _context.p = 3;
              _context.n = 4;
              return this.subscribeToBackInStock(email);
            case 4:
              this.showSuccessState();
              this.emailInput.value = '';
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.error('Error subscribing to back in stock:', _t);
              this.showMessage('Something went wrong. Please try again later.', 'error');
              this.setLoadingState(false);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[3, 5]]);
      }));
      function handleSubmit(_x) {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }()
  }, {
    key: "validateEmail",
    value: function validateEmail(email) {
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }
  }, {
    key: "subscribeToBackInStock",
    value: function () {
      var _subscribeToBackInStock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(email) {
        var klaviyoPublicApiKey, variantIdentifier, payload, response, _errorData$errors, errorData, errorMessage;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(!this.variantId || !this.productId)) {
                _context2.n = 1;
                break;
              }
              throw new Error('Missing variant or product ID');
            case 1:
              klaviyoPublicApiKey = this.getKlaviyoPublicApiKey();
              variantIdentifier = "$shopify:::$default:::".concat(this.variantId);
              payload = {
                data: {
                  type: 'back-in-stock-subscription',
                  attributes: {
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email: email
                        }
                      }
                    },
                    channels: ['EMAIL']
                  },
                  relationships: {
                    variant: {
                      data: {
                        type: 'catalog-variant',
                        id: variantIdentifier
                      }
                    }
                  }
                }
              };
              _context2.n = 2;
              return fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=".concat(klaviyoPublicApiKey), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'revision': '2023-12-15'
                },
                body: JSON.stringify(payload)
              });
            case 2:
              response = _context2.v;
              if (response.ok) {
                _context2.n = 4;
                break;
              }
              _context2.n = 3;
              return response.json()["catch"](function () {
                return {};
              });
            case 3:
              errorData = _context2.v;
              errorMessage = ((_errorData$errors = errorData.errors) === null || _errorData$errors === void 0 || (_errorData$errors = _errorData$errors[0]) === null || _errorData$errors === void 0 ? void 0 : _errorData$errors.detail) || errorData.detail || "HTTP error! status: ".concat(response.status);
              throw new Error(errorMessage);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function subscribeToBackInStock(_x2) {
        return _subscribeToBackInStock.apply(this, arguments);
      }
      return subscribeToBackInStock;
    }()
  }, {
    key: "getKlaviyoPublicApiKey",
    value: function getKlaviyoPublicApiKey() {
      return 'Tcu7BE';
    }
  }, {
    key: "setLoadingState",
    value: function setLoadingState(isLoading) {
      if (this.submitButton) {
        this.submitButton.disabled = isLoading;
        if (isLoading) {
          this.submitButton.textContent = 'Subscribing...';
        } else {
          this.submitButton.textContent = 'Notify Me';
        }
      }
      if (this.emailInput) {
        this.emailInput.disabled = isLoading;
      }
    }
  }, {
    key: "showSuccessState",
    value: function showSuccessState() {
      if (this.submitButton) {
        this.submitButton.textContent = 'Thank You!';
        this.submitButton.disabled = true;
      }
      if (this.emailInput) {
        this.emailInput.disabled = true;
      }
      this.showMessage('You\'ll be notified when this product is back in stock!', 'success');
    }
  }, {
    key: "showMessage",
    value: function showMessage(message, type) {
      var _this2 = this;
      if (!this.messageContainer) {
        return;
      }
      this.messageContainer.textContent = message;
      this.messageContainer.className = "back-in-stock-form__message back-in-stock-form__message--".concat(type);
      this.messageContainer.setAttribute('role', 'status');
      this.messageContainer.setAttribute('aria-live', 'polite');
      setTimeout(function () {
        if (_this2.messageContainer) {
          _this2.messageContainer.textContent = '';
          _this2.messageContainer.className = 'back-in-stock-form__message';
        }
      }, 5000);
    }
  }, {
    key: "updateVariant",
    value: function updateVariant(variantId, productId, productTitle, variantTitle) {
      this.variantId = variantId;
      this.productId = productId;
      this.productTitle = productTitle;
      this.variantTitle = variantTitle;
      if (this.dataset) {
        this.dataset.variantId = variantId;
        this.dataset.productId = productId;
        this.dataset.productTitle = productTitle;
        this.dataset.variantTitle = variantTitle;
      }
      if (this.emailInput) {
        this.emailInput.value = '';
      }
      if (this.messageContainer) {
        this.messageContainer.textContent = '';
        this.messageContainer.className = 'back-in-stock-form__message';
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
export default BackInStock;